"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var classnames_1 = __importDefault(require("classnames"));

var react_transition_group_1 = require("react-transition-group");

require("./SzSideMenu.scss");

function SzSideMenu(_a) {
  var children = _a.children,
      className = _a.className,
      isOpen = _a.isOpen;
  var menuClasses = classnames_1.default('sz-aside overflow-hidden bg-white text-primary', className, {
    open: isOpen
  });
  return react_1.default.createElement(react_transition_group_1.CSSTransition, {
    in: isOpen,
    timeout: 0,
    classNames: "sz-aside"
  }, react_1.default.createElement("aside", {
    className: menuClasses
  }, react_1.default.createElement("nav", null, children)));
}

exports.default = SzSideMenu;
SzSideMenu.defaultProps = {
  isOpen: true
};
SzSideMenu.propTypes = {
  children: prop_types_1.default.node,
  className: prop_types_1.default.string,
  isOpen: prop_types_1.default.bool
};